import { render, staticRenderFns } from "./ModalContainer.vue?vue&type=template&id=67aa027b&scoped=true&"
import script from "./ModalContainer.vue?vue&type=script&lang=js&"
export * from "./ModalContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModalContainer.vue?vue&type=style&index=0&id=67aa027b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa027b",
  null
  
)

export default component.exports